/* angular:styles/component:css;2e1604c79e2429222d257aebe224fee54610f476c4bb458ecb6eb9b98167dc19;/Users/daniyal/Cuboid AS Dropbox/Daniyal Ahmed/Development/friggkantine-admin/projects/portal/src/app/pages/employees/employee-dialog.component.ts */
.full {
  width: 100%;
}
.group-hint {
  color: #7b8794;
  font-size: 12px;
}
.invite-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #46617a;
  margin: 4px 0 8px;
  cursor: pointer;
}
.readonly-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  margin: 0 0 18px;
}
.readonly-label {
  font-size: 12px;
  color: #8593a1;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.readonly-value {
  font-size: 14px;
}
.dialog-error {
  color: #b3271e;
  font-size: 13px;
  margin: 0;
}
/*# sourceMappingURL=employee-dialog.component.css.map */
